/**
 * The pipeline order, used only until `GET /workflow/stages` answers (and as
 * the stage key type). The server's `App\Workflow\Support\Pipeline` is the
 * source of truth; `tests/unit/workflow-order.test.ts` fails the build if this
 * copy drifts from it.
 */
export const EXTERNAL_LAB_STAGES = [
  'registration',
  'sticking',
  'review',
  'ready_for_packing'
] as const;

export const INTERNAL_LAB_STAGES = [
  'reception',
  'sorting',
  'handover_scanning',
  'photo_scanning',
  'qr_review',
  'ocr',
  'qa1_ocr',
  'qa2_ocr',
  'qa3_ocr',
  'warehouse',
  'archived'
] as const;

export const PIPELINE_STAGES = [
  ...EXTERNAL_LAB_STAGES,
  ...INTERNAL_LAB_STAGES
] as const;
